export default __webpack_public_path__ + "static/media/webiste-bg.5f4e065c.jpg";